module.exports = __webpack_public_path__ + "static/media/file.722eea83.svg";